import { useState } from "react";
import { Upload, X, Loader2, Link2 } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl, formatApiError } from "@/lib/api";

export const ImageUploader = ({ images, onChange, multiple = true, testid = "image-uploader" }) => {
  const [busy, setBusy] = useState(false);
  const [link, setLink] = useState("");

  const upload = async (files) => {
    setBusy(true);
    const urls = [];
    for (const f of Array.from(files)) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post("/upload", fd);
        urls.push(data.url);
      } catch (e) {
        toast.error(`${f.name}: ${formatApiError(e.response?.data?.detail)}`);
      }
    }
    onChange(multiple ? [...images, ...urls] : urls.slice(0, 1));
    setBusy(false);
  };

  const addLink = () => {
    if (!link.trim()) return;
    onChange(multiple ? [...images, link.trim()] : [link.trim()]);
    setLink("");
  };

  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-4 gap-2">
        {images.map((src, i) => (
          <div key={src + i} className="relative aspect-square border border-[#D4AF37]/20 overflow-hidden group">
            <img src={imgUrl(src)} alt="" className="w-full h-full object-cover" />
            {i === 0 && <span className="absolute bottom-1 left-1 font-mono-j text-[9px] bg-[#0D0D11]/80 text-[#E5C158] px-1">COVER</span>}
            <button type="button" onClick={() => onChange(images.filter((_, j) => j !== i))} data-testid={`${testid}-remove-${i}`}
              className="absolute top-1 right-1 w-6 h-6 grid place-items-center rounded-full bg-[#0D0D11]/80 text-[#F5F3EF]">
              <X className="w-3 h-3" />
            </button>
          </div>
        ))}
        <label className="aspect-square border border-dashed border-[#D4AF37]/40 grid place-items-center cursor-pointer text-[#E5C158] hover:bg-[#D4AF37]/5 transition-colors">
          {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <span className="flex flex-col items-center gap-1 text-[11px]"><Upload className="w-5 h-5" />Upload</span>}
          <input type="file" accept="image/*" multiple={multiple} hidden disabled={busy} data-testid={`${testid}-input`}
            onChange={(e) => { upload(e.target.files); e.target.value = ""; }} />
        </label>
      </div>
      <div className="mt-2 flex gap-2">
        <div className="relative flex-1">
          <Link2 className="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-[#A09E97]" />
          <input value={link} onChange={(e) => setLink(e.target.value)} placeholder="…or paste an image link" data-testid={`${testid}-link-input`}
            className="w-full h-9 bg-[#0D0D11] border border-[#D4AF37]/20 pl-9 pr-3 text-xs text-[#F5F3EF] focus:outline-none focus:border-[#D4AF37]" />
        </div>
        <button type="button" onClick={addLink} data-testid={`${testid}-link-add`} className="h-9 px-3 text-xs border border-[#D4AF37]/30 text-[#E5C158]">Add</button>
      </div>
    </div>
  );
};
